module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00066-fs8.54d3b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00066-fs8.png
// module id = 219
// module chunks = 0